(function () {
  "use strict";
  const contextPatterns = [
    ["boulangerie-pâtisserie", "Boulangerie-pâtisserie"],
    ["boulangerie", "Boulangerie"],
    ["charcuterie", "Charcuterie"],
    ["boucherie artisanale", "Boucherie artisanale"],
    ["boucherie", "Boucherie"],
    ["épicerie fine", "Épicerie fine"],
    ["epicerie fine", "Épicerie fine"],
    ["café", "Café"],
    ["cafe", "Café"],
    ["restaurant", "Restaurant"],
    ["comptoir de boutique", "Comptoir de boutique"],
    ["boutique", "Boutique"],
    ["bureau à domicile", "Bureau à domicile"],
    ["bureau", "Bureau"],
    ["îlot de cuisine", "Îlot de cuisine"],
    ["ilot de cuisine", "Îlot de cuisine"],
    ["cuisine", "Cuisine"],
    ["salle de réunion", "Salle de réunion"],
    ["salle à manger", "Salle à manger"],
    ["hall d’accueil", "Hall d’accueil"],
    ["hall d'accueil", "Hall d’accueil"],
    ["salon", "Salon"],
    ["chambre", "Chambre"],
    ["entrée", "Entrée"]
  ];

  function labelFromAlt(alt, current) {
    const scene = alt.match(/scène d['’]ambiance\s*,\s*([^:]+)\s*:/i);
    if (scene) return scene[1].trim();
    const normalized = alt.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
    for (const entry of contextPatterns) {
      const key = entry[0].normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
      if (normalized.includes(key)) return entry[1];
    }
    if (current && !/^(mise en situation|ambiance\s*\d*)$/i.test(current.trim())) return current.trim();
    return "";
  }

  function installLayoutStyles(root) {
    if (root.querySelector("style[data-lf-layout-guard]")) return;
    const style = document.createElement("style");
    style.setAttribute("data-lf-layout-guard", "true");
    style.textContent = `
      :host .instant .lf-situation-scene,
      :host .instant .lf-v74-tech-panel,
      :host .instant .ic-panels {
        width: 100% !important;
        max-width: 1280px !important;
        min-width: 0 !important;
        margin-inline: auto !important;
        box-sizing: border-box !important;
        overflow: hidden !important;
      }
      :host .instant .lf-v74-tech-panel,
      :host .instant .ic-panels {
        border: 0 !important;
        border-radius: 0 !important;
        background: transparent !important;
        box-shadow: none !important;
      }
      :host .instant .lf-situation-scene__layout {
        display: grid !important;
        grid-template-columns: minmax(0, .9fr) minmax(0, 1fr) !important;
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;
        margin: 0 auto !important;
        box-sizing: border-box !important;
      }
      :host .instant .lf-situation-scene__visual,
      :host .instant .lf-situation-scene__copy,
      :host .instant .lf-situation-scene__thumbs,
      :host .instant .lf-situation-scene__thumb,
      :host .instant .ic-panels > div,
      :host .instant .ic-panels > div > details,
      :host .instant .ic-panels > div > details > summary,
      :host .instant .ic-panel-body,
      :host .instant .lf-category-specs,
      :host .instant .lf-category-specs-grid,
      :host .instant .lf-v74-full-grid,
      :host .instant .lf-v74-full-card {
        min-width: 0 !important;
        max-width: 100% !important;
        box-sizing: border-box !important;
      }
      :host .instant .ic-panels > div {
        width: 100% !important;
        max-width: 1280px !important;
        margin-inline: auto !important;
      }
      :host .instant .ic-panels > div > details {
        width: 100% !important;
        margin-inline: 0 !important;
        overflow: hidden !important;
      }
      :host .instant .lf-panel-heading-copy,
      :host .instant .lf-panel-heading-copy h2,
      :host .instant .lf-panel-subtitle,
      :host .instant .lf-category-spec-value {
        overflow-wrap: anywhere !important;
      }
      :host .instant .lf-category-specs-grid,
      :host .instant .lf-v74-full-grid {
        display: grid !important;
        grid-template-columns: repeat(auto-fit, minmax(min(100%, 240px), 1fr)) !important;
      }
      :host .instant .lf-situation-scene__visual {
        display: flex !important;
        flex-direction: column !important;
        gap: 8px !important;
        position: static !important;
        width: 100% !important;
        min-height: 0 !important;
        max-height: none !important;
        aspect-ratio: auto !important;
        overflow: visible !important;
        border-radius: 0 !important;
        background: transparent !important;
      }
      :host .instant .lf-situation-scene__image-stage {
        position: relative !important;
        width: 100% !important;
        min-height: 0 !important;
        max-height: 520px !important;
        aspect-ratio: 4 / 3 !important;
        overflow: hidden !important;
        border-radius: 11px !important;
      }
      :host .instant .lf-situation-scene__image-stage .lf-situation-scene__slide {
        position: absolute !important;
        inset: 0 !important;
        width: 100% !important;
        height: 100% !important;
      }
      :host .instant .lf-situation-scene__visual img {
        max-width: 100% !important;
        object-fit: cover !important;
      }
      :host .instant .lf-situation-scene__thumbs {
        order: -1 !important;
        display: grid !important;
        grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
        gap: 8px !important;
        margin: 0 !important;
        padding: 0 !important;
      }
      :host .instant .lf-situation-scene__thumb {
        width: 100% !important;
        overflow: hidden !important;
        overflow-wrap: anywhere !important;
      }
      @media (max-width: 749px) {
        :host .instant .lf-situation-scene__layout {
          grid-template-columns: minmax(0, 1fr) !important;
          gap: 14px !important;
        }
        :host .instant .lf-situation-scene__image-stage {
          max-height: 360px !important;
        }
        :host .instant .lf-situation-scene__thumbs {
          grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
        }
        :host .instant .ic-panels > div {
          padding-inline: 12px !important;
        }
        :host .instant .ic-panels > div > details > summary {
          gap: 8px !important;
        }
        :host .instant .lf-category-specs-grid,
        :host .instant .lf-v74-full-grid {
          grid-template-columns: minmax(0, 1fr) !important;
        }
      }
    `;
    root.appendChild(style);
  }

  function normalizeDimensionText(root) {
    function normalize() {
      root.querySelectorAll(".lf-featured-card").forEach(function (card) {
        const label = card.querySelector(".lf-featured-label");
        const value = card.querySelector(".lf-featured-value");
        if (!label || !value || label.textContent.trim().toLowerCase() !== "dimensions") return;
        const original = value.textContent || "";
        const cleaned = original.replace(/\s+m\s+cm\s*$/i, " m").trim();
        if (cleaned !== original.trim()) value.textContent = cleaned;
      });
    }
    normalize();
    if (root.__lfDimensionTextObserver) return;
    const observer = new MutationObserver(normalize);
    observer.observe(root, { childList: true, characterData: true, subtree: true });
    root.__lfDimensionTextObserver = observer;
  }

  function update() {
    let updated = false;
    document.querySelectorAll("instant-layout").forEach(function (host) {
      const root = host.shadowRoot;
      if (!root) return;
      installLayoutStyles(root);
      normalizeDimensionText(root);
      const gallery = root.querySelector("[data-lf-scene-gallery]");
      if (!gallery) return;
      const slides = Array.from(gallery.querySelectorAll("[data-lf-scene-slide]"));
      const thumbs = Array.from(gallery.querySelectorAll("[data-lf-scene-thumb]"));
      const labels = slides.map(function (slide, index) {
        const existing = slide.getAttribute("data-room") || "";
        const label = labelFromAlt(slide.getAttribute("alt") || "", existing);
        if (!label) return existing;
        slide.setAttribute("data-room", label);
        const text = thumbs[index] && thumbs[index].querySelector("span");
        if (text) text.textContent = label;
        if (thumbs[index]) thumbs[index].setAttribute("aria-label", "Afficher l’ambiance " + label);
        return label;
      });
      const room = gallery.querySelector(".lf-situation-scene__room");
      const sceneCopy = gallery.querySelector(".lf-situation-scene__text");
      const benefitTexts = Array.from(gallery.querySelectorAll(".lf-situation-scene__benefit span"));
      const benefitIcons = Array.from(gallery.querySelectorAll(".lf-situation-scene__benefit svg"));
      function sceneDetails(label) {
        const key = (label || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
        const shield = '<path d="M12 3 20 6v5c0 4.5-3.1 8.2-8 10-4.9-1.8-8-5.5-8-10V6l8-3Z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>';
        const line = '<path d="M3 17h18M5 17V8h14v9M8 12h8" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>';
        if (key.includes("bureau")) return {
          copy: "Sous l’étagère, le ruban COB crée une ligne lumineuse continue au-dessus du poste de travail.",
          benefits: ["Éclairage du poste de travail", "COB, ligne lumineuse continue", "IP65 : pose protégée, hors immersion"],
          icons: ['<rect x="3" y="4" width="18" height="13" rx="2" fill="none" stroke="currentColor" stroke-width="1.6"/><path d="M8 21h8M12 17v4" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>', line, shield]
        };
        if (key.includes("boutique")) return {
          copy: "Sous une tablette, la lumière linéaire souligne vêtements, accessoires et présentoirs.",
          benefits: ["Présentoirs et étagères soulignés", "480 LED/m pour une ligne homogène", "IP65 : pose protégée, hors immersion"],
          icons: ['<path d="M4 20V8h16v12M2 8h20l-2-5H4L2 8ZM8 12h8M9 15h6" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>', line, shield]
        };
        if (key.includes("hall") || key.includes("accueil")) return {
          copy: "Dans une gorge de plafond, la ligne lumineuse accompagne l’accueil et la circulation.",
          benefits: ["Ligne intégrée dans une gorge", "Éclairage homogène des passages", "IP65 : pose protégée, hors immersion"],
          icons: ['<path d="M4 21V5l8-2 8 2v16M9 21v-6h6v6M8 8h1m6 0h1m-7 4h1m6 0h1" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>', line, shield]
        };
        if (key.includes("plan de travail")) return {
          copy: "Sous l’étagère, le ruban éclaire le plan de travail et se coupe aux repères tous les 5 cm.",
          benefits: ["Lumière sous étagère", "Découpe aux repères tous les 5 cm", "IP65 : pose protégée, hors immersion"],
          icons: ['<path d="M3 8h18M5 8v13m14-13v13M8 8V4m8 4V4M3 13h18M8 13v3m4-3v5m4-5v3" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>', '<circle cx="6" cy="6" r="2" fill="none" stroke="currentColor" stroke-width="1.6"/><circle cx="6" cy="18" r="2" fill="none" stroke="currentColor" stroke-width="1.6"/><path d="m8 7 12 10M8 17 20 7" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>', shield]
        };
        return null;
      }
      function syncRoom() {
        const active = slides.findIndex(function (slide) { return !slide.hidden; });
        if (active < 0 || !labels[active]) return;
        if (room) room.textContent = labels[active];
        const details = sceneDetails(labels[active]);
        if (!details) return;
        if (sceneCopy) sceneCopy.textContent = details.copy;
        benefitTexts.forEach(function (node, index) {
          if (details.benefits[index]) node.textContent = details.benefits[index];
        });
        benefitIcons.forEach(function (icon, index) {
          if (details.icons[index]) icon.innerHTML = details.icons[index];
        });
      }
      syncRoom();
      if (gallery.dataset.lfContextLabelsBound !== "true") {
        gallery.dataset.lfContextLabelsBound = "true";
        gallery.addEventListener("click", function (event) {
          if (event.target.closest("[data-lf-scene-thumb], [data-lf-scene-prev], [data-lf-scene-next]")) {
            setTimeout(syncRoom, 0);
          }
        });
        gallery.addEventListener("touchend", function () { setTimeout(syncRoom, 0); }, { passive: true });
      }
      updated = true;
    });
    return updated;
  }

  let attempts = 0;
  const timer = setInterval(function () {
    attempts += 1;
    if (update() || attempts >= 60) clearInterval(timer);
  }, 250);
  if (document.readyState !== "loading") update();
  else document.addEventListener("DOMContentLoaded", update, { once: true });
})();